export default "__VITE_ASSET__06851a0e__"